import { createContext } from "react";
import type { TeamRole } from "../features/identity/TeamRole";

/**
 * The team is chosen once and holds for the whole app. Every view used to ask for it again,
 * which for a club with a single team meant one mandatory tap per page before anything loaded
 * at all.
 *
 * The team now comes from the signed-in account rather than from the first entry of a list, and
 * the role travels with it. The category used to live here as well; it moved to the team page on
 * 24.09.2026, because that page is the only one that uses it and it now starts from the running
 * season instead of from a stored choice.
 */
export interface TeamScopeValue {
  /** Empty while the answer is still loading, or when the account belongs to no team. */
  team: string;
  teams: string[];
  /**
   * Null while nothing has been verified. Rights are never derived from a null role -
   * absence means unknown, not permitted.
   */
  role: TeamRole | null;
  /** True from captaincy upwards - an administrator outranks a captain. */
  isCaptain: boolean;
  isAdmin: boolean;
  loading: boolean;
  error: string | null;
  setTeam: (team: string) => void;
}

export const TeamScopeContext = createContext<TeamScopeValue | undefined>(undefined);
